import { TradeTypeEnum } from '../Types'

export const tradeTypeEnumToDisplay = (type: TradeTypeEnum) => {
  switch (type) {
    case TradeTypeEnum.allocation:
      return 'Allocation Trade'
    case TradeTypeEnum.execution:
      return 'Apex Trade'
    case TradeTypeEnum.awayTrade:
      return 'Away Trade'
    default:
      return type
  }
}

export const tradeTypeDisplayToEnum = (type: string) => {
  switch (type) {
    case 'Apex Trade':
      return TradeTypeEnum.execution
    case 'Away Trade':
      return TradeTypeEnum.awayTrade
    case 'Allocation Trade':
      return TradeTypeEnum.allocation
    default:
      return type
  }
}
